var _excluded = ["option", "optionRenderer", "onClick", "isSelected", "id", "setActiveOptionId"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useListItem, useMergeRefs } from '@floating-ui/react';
import { forwardRef } from 'react';
import { useBaseMenuContext } from '../../../../containers/BaseMenu/hooks';
import { useMultiStyleConfig } from '../../../../utils/use-style-config';
import { Text, Tooltip } from '../../../dataDisplay';
import { Box, ConditionalWrapper } from '../../../internal';
import { jsx as _jsx } from "react/jsx-runtime";

var OptionComponent = (_ref, propRef) => {
  var _option$disabled, _option$disabled2, _optionRenderer;

  var {
    option,
    optionRenderer,
    onClick,
    isSelected,
    id,
    setActiveOptionId
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var styles = useMultiStyleConfig('SelectNew', {});
  var {
    activeIndex,
    getItemProps
  } = useBaseMenuContext();
  var {
    ref: itemRef,
    index
  } = useListItem({
    label: option.label
  });
  var ref = useMergeRefs([itemRef, propRef]);
  var disabledMessage = (_option$disabled = option.disabled) === null || _option$disabled === void 0 ? void 0 : _option$disabled.message;
  var isDisabled = ((_option$disabled2 = option.disabled) === null || _option$disabled2 === void 0 ? void 0 : _option$disabled2.isDisabled) || false;
  var isActive = !isDisabled && activeIndex === index;
  return /*#__PURE__*/_jsx(ConditionalWrapper, {
    condition: Boolean(isDisabled && disabledMessage),
    wrapper: children => /*#__PURE__*/_jsx(Tooltip, {
      label: disabledMessage,
      children: children
    }),
    children: /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      "data-component": "SelectNew.Option",
      __css: styles['option'],
      as: "button" // ts-ignore is used due to `type` issue with `Box`.
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      ,
      type: "button",
      role: "option",
      "data-active": isActive || undefined,
      "aria-selected": isSelected,
      "aria-disabled": isDisabled,
      tabIndex: isActive ? 0 : -1,
      id: id
    }, getItemProps(_objectSpread({}, !isDisabled && {
      onClick,
      onFocus: () => setActiveOptionId(id),
      onBlur: () => setActiveOptionId('')
    }))), otherProps), {}, {
      children: (_optionRenderer = optionRenderer === null || optionRenderer === void 0 ? void 0 : optionRenderer(option, isSelected)) !== null && _optionRenderer !== void 0 ? _optionRenderer : /*#__PURE__*/_jsx(Text, {
        textStyle: "inline",
        color: "inherit",
        shouldSupportEllipsis: true,
        children: option.label
      })
    }))
  });
};

export var Option = /*#__PURE__*/forwardRef(OptionComponent);
Option.displayName = 'SelectNew.Option';
//# sourceMappingURL=Option.js.map